module.exports = __webpack_public_path__ + "img/icon-aep.0ac13269.svg";